<mat-card>
    <mat-card-header>
        <mat-card-title class="popupHeader">
            <div class="mat-card-header-text" i18n>
                Email Settings
              </div> 
        </mat-card-title>
        <button mat-icon-button i18n-matTooltip matTooltip="Check connection" tabindex="-1" (click)="checkConnection()">
            <mat-icon>network_check</mat-icon>
        </button> 
    </mat-card-header>

    <mat-card-content>
        <form>
            <mat-form-field class="my-form-field"> 
                <mat-label>Server</mat-label>      
                <input matInput name="server" [(ngModel)]="server" [value]="server" type="text">
            </mat-form-field>

            <mat-form-field class="my-form-field"> 
                <mat-label>Port</mat-label>      
                <input matInput name="port" [(ngModel)]="port" [value]="port" type="text">
            </mat-form-field>

            <mat-form-field class="my-form-field"> 
                <mat-label>Email</mat-label>      
                <input matInput name="email" [(ngModel)]="email" [value]="email" type="text">
            </mat-form-field>

            <mat-form-field class="my-form-field"> 
                <mat-label i18n>Password</mat-label>      
                <input matInput name="pass" type="password" [(ngModel)]="pass" [value]="pass">
            </mat-form-field>
            
            <div class="checkboxDiv">
                <label class="textStyle">SSL</label>
                <input name="ssl" [(ngModel)]="ssl" [value]="ssl" type="checkbox" />
            </div>

            <mat-form-field class="my-form-field emailContent"> 
                <mat-label i18n>Test Email</mat-label>      
                <input matInput name="testemail" [value]="testemail" [(ngModel)]="testemail" type="email" [disabled]="!isTestMode">
            </mat-form-field>
        </form>
    </mat-card-content>

    <mat-card-actions>
        <div class="buttonContent">
            <button mat-raised-button type="button" color="primary" [style.visibility]="isTestMode ? 'visible':'hidden'" (click)="sendEmail()" i18n>TEST</button>
            <button mat-raised-button type="button" color="primary" (click)="onSave()" i18n>SAVE</button>
        </div>        
    </mat-card-actions>
    </mat-card>